module.exports = __webpack_public_path__ + "static/media/neurotoolkit.90113a35.png";


//////////////////
// WEBPACK FOOTER
// ./src/neurotoolkit.png
// module id = 80
// module chunks = 0